import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import {toast} from "react-toastify";

const baseQueryConfig = fetchBaseQuery({
  baseUrl: "https://pmsapidev.visioncollab.com/api",
  // // credentials: "include",
  // prepareHeaders: (headers, api) => {
  //   const { user } = api.getState().auth;
  //   if (user?.token) {
  //     headers.set("Authorization", `Bearer ${user.token}`);
  //   }
  //   return headers;
  // },
});


const interceptBaseQuery = async (args, api, extraOptions) => {
  const response = await baseQueryConfig(args, api, extraOptions);
  const { data } = response;
  if(data && [200,1,"200","1"].includes(data.status) && data.message){
    toast.success(data.message)
  }else{
    toast.error(data.message)
  }
  return response;
};

const apiSlice = createApi({
  reducerPath: "apiSlice",
  baseQuery: interceptBaseQuery,
  endpoints: () => ({}),
});

export default apiSlice;
